import React, { useState } from "react";
import styles from "./Auth.module.css";
import { useParams } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import Button from 'react-bootstrap/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import NavigationBar from "../../components/navbar/NavigationBar";

function Auth() {
    const [year, setYear] = useState(new Date().getFullYear()); // Initialize with current year
    const { authentication } = useParams(); // Get the authentication type from URL
    const navigate = useNavigate();

    return (
        <div className={styles["authentication-container"]}>
            <div className={styles["navbar-hider"]}>
                <NavigationBar className={styles["auth-navbar"]} />
            </div>

            <div className={styles["authentication-content"]}>
                <div className={styles["auth-banner"]}>
                    <div className={styles["auth-banner-header"]}>
                        <img className={styles["logo"]} src="/assets/images/logo.webp" alt="logo" />

                        <Button 
                            className={styles["btn-transparent"]}
                            href="/"
                            // onClick={() => navigate("/")}
                        >
                            <ArrowBackIcon className={styles["btn-arrow"]}/>
                            Back to website 
                        </Button>
                    </div>

                    <p className={styles["copy-right"]}>Copyright © {year} Presage Technologies</p>
                </div>

                <div className={styles["auth-form-container"]}>
                    {authentication === "login" ? <Login /> : <Register />}
                </div>
            </div>
        </div>
    )
}

export default Auth;